import { render, staticRenderFns } from "./invasions-list.vue?vue&type=template&id=178c7867&lang=pug&"
import script from "./invasions-list.vue?vue&type=script&lang=js&"
export * from "./invasions-list.vue?vue&type=script&lang=js&"
import style0 from "./invasions-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports